import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { coordinationKeys, eventKeys, taskKeys } from '../../../global/contexts/work/keys';
import { taskPaths } from '../../../global/contexts/work/paths';

// Core: POST admin/tasks/{id}/review-round/decision with
// { review_round_id, result: 'approved'|'returned', reason }. Needs
// tasks:review, a human session and QA/lead capability in the project.
export function useDecideReview(taskId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ roundId, result, reason }) => {
            const body = { review_round_id: roundId, result };
            if (reason) body.reason = reason;
            return (await api.post(taskPaths.decision(taskId), body)).data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: taskKeys.all });
            queryClient.invalidateQueries({ queryKey: eventKeys.all });
            queryClient.invalidateQueries({ queryKey: coordinationKeys.attentionAll });
        },
    });
}
